import { useEffect } from 'react';
import { usePosts } from './posts';
import PostCard from './PostCard';
import './Aktuelles.css';

// Anzahl der Posts auf der Startseite – alle weiteren auf /news
const HOME_LIMIT = 2;

function Aktuelles() {
  // Einen Post mehr laden, um zu wissen, ob es auf /news noch mehr gibt
  const posts = usePosts(HOME_LIMIT + 1);

  // Bei Rückkehr von /news (/#aktuelles) zur Sektion scrollen – sie existiert
  // erst nach dem Laden, daher greift der Browser-Anker nicht von selbst
  useEffect(() => {
    if (posts && posts.length > 0 && window.location.hash === '#aktuelles') {
      document.getElementById('aktuelles')?.scrollIntoView();
    }
  }, [posts]);

  // Sektion ausblenden, solange nichts geladen oder keine Posts vorhanden sind
  if (!posts || posts.length === 0) return null;

  const hasMore = posts.length > HOME_LIMIT;

  return (
    <section id="aktuelles" className="aktuelles">
      <div className="aktuelles__inner">

        <div className="aktuelles__header">
          <span className="aktuelles__label">Neuigkeiten</span>
          <h2 className="aktuelles__title">Aktuelles</h2>
          <div className="aktuelles__divider" />
        </div>

        <div className="aktuelles__grid">
          {posts.slice(0, HOME_LIMIT).map((post) => (
            <PostCard key={post._id} post={post} />
          ))}
        </div>

        {hasMore && (
          <div className="aktuelles__more">
            <a href="/news" className="btn btn--outline">Alle Neuigkeiten</a>
          </div>
        )}

      </div>
    </section>
  );
}

export default Aktuelles;
